const ErrorMessages = {
  NoInvestmentsFoundForDate:
    'No investments found for this investor at that date.',
};

export { ErrorMessages };
